import { render, staticRenderFns } from "./a-heading-rich-minimal.vue?vue&type=template&id=c29b23c2&"
import script from "./a-heading-rich-minimal.vue?vue&type=script&lang=js&"
export * from "./a-heading-rich-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports